import { DynamicHead } from '@lemon8/web-app-shared/ssr';
import { FC } from 'react';

export const PolicyHead: FC = () => {
  return (
    <DynamicHead>
      <title>Law Enforcement Guidelines</title>
    </DynamicHead>
  );
};
